import { PDFViewCtrl } from '@foxitsoftware/foxit-pdf-sdk-for-web-library'

export const FoxItFieldTypes: Record<string, number> = {
	button: 1,
	signature: 7,
	text: 6,
	checkbox: 2,
}

export const flagStatuses: Record<number, string> = {
	0: 'No special flags',
	1: 'Read-only',
	2: 'Required',
	4: 'Hidden',
	8: 'No export',
}

export type FoxItSignature = {
	dataURL: string
	isEncryption: boolean
	password: string | null
	encipherment: string | null
}

// @ts-ignore incorrectly typed in Foxit SDK
export interface FoxItField extends PDFViewCtrl.PDF.annots.form.PDFField {
	form: FoxItPDFForm
	name: string
	info: {
		name: string
		alternateName: string
		type: number
		value: string
		controls: {
			isChecked: boolean
		}[]
		flag: number
	}
	getFlags: () => number
	setValue: (value: string) => void
	setFlags: (value: number) => void
	setOptions: (value: { selected: boolean }) => void
	// @ts-ignore incorrectly typed in Foxit SDK
	getControlByIndex: (index: number) => PDFViewCtrl.PDF.annots.form.PDFControl
}

export interface FoxItPage extends PDFViewCtrl.PDF.PDFPage {
	info: {
		index: number
	}
	getHeight(): number
	getIndex(): number
}

export type SignaturePlacement = {
	fieldName: string
	rect: FoxItRect
	pageIndex: number
}

export type FoxItRect = {
	left: number
	top: number
	right: number
	bottom: number
}

export interface FoxItAnnot extends PDFViewCtrl.PDF.annots.Annot {
	getPage: () => FoxItPage
	info: {
		name: string
		rect: FoxItRect
		objectNumber: number
	}
	page: {
		removeAnnotByObjectNumber: (objNum: number) => Promise<FoxItAnnot[]>
	}
}

export interface FoxItAnnotScreen extends PDFViewCtrl.PDF.annots.Screen {
	setImage: (buffer: ArrayBuffer) => Promise<boolean>
}

// @ts-ignore incorrectly typed in Foxit SDK
export interface FoxItPDFForm extends PDFViewCtrl.PDF.annots.form {
	fields: FoxItField[]
	// addControl
	addControl: (
		pageIndex: number,
		fieldName: string,
		fieldType: number,
		rect: Record<string, number>
	) => Promise<{ success: boolean; newFieldName: string }>
	getField: (value: string) => FoxItField
	// Runs the PDF's own calculation scripts (e.g. totals) in its calculation order
	calculate: (field: FoxItField) => void
	removeField: (value: string) => Promise<Boolean>
	addSignature: (
		pageIndex: number,
		rect: FoxItRect,
		fieldName: string
	) => Promise<FoxItField>
}

export interface FoxItComponent {
	setValue: (value: string) => void
}

export const FoxItScreen = PDFViewCtrl.PDF.annots.constant.Annot_Type.screen

export const FoxItHandState =
	PDFViewCtrl.constants.STATE_HANDLER_NAMES.STATE_HANDLER_HAND

export const FoxItFieldFlags = {
	TextDoNotSpellCheck:
		PDFViewCtrl.PDF.form.constant.Field_Flag.TextDoNotSpellCheck,
	ReadOnly: PDFViewCtrl.PDF.form.constant.Field_Flag.ReadOnly,
}
